import $ from 'jquery'
import { environment } from '@/utils/environmentUtils'
// @ts-expect-error TODO: Add types for easyrec, or just leave it since easyrec is legacy
import easyrec from '@/easyrec'

interface Options {
  itemId: string
  itemDescription: string
  itemUrl: string
  itemImageUrl: string
  userId?: string
}

export const trackEasyrecView = () => {
  // Don't log views in non-prod environments so that stats aren't skewed by internal users and testing
  if (environment !== 'production') {
    return
  }

  const optionsWithUid = async (options: Options) => ({
    ...options,
    ...(window._mktoPageData?.user?.uid && {
      userId: window._mktoPageData.user.uid
    })
  })

  const itemId = window.item && window.item.id
  if (!itemId) {
    return
  }

  $.get('/api/v2/items/' + itemId).done(function (product) {
    // Don't log add-ons or custom items or envelopes
    if (/^(X|C|E|Z)/.test(product.code)) {
      return
    }

    const options = {
      itemId: product.code,
      itemDescription: product.shortTitle,
      // Don't log type because we'll have to reconfigure easyrec every time we add a new type
      // itemType: product.format.type.toUpperCase(),
      itemUrl: product.seoPath,
      itemImageUrl: product.hugeImageUrl
    }

    easyrec.view(optionsWithUid(options))
  })
}
